import { wearUrl } from '~/features/shared/domain/wearUrl'
import { NormalizedConditions } from '../types'
import { withDefaultValues } from '../utils/withDefaultValues'
import { buildPath } from './path'
import { buildQuery } from './query'

/**
 * Build url path and query string
 * @param conditions NormalizedConditions
 * @returns {string} url path and query string
 */
export const buildUrl = (conditions: Partial<NormalizedConditions>): string => {
  const filledConditions = withDefaultValues(conditions)
  const url = wearUrl(buildPath(filledConditions))
  url.search = buildQuery(filledConditions).toString()
  return url.href.replace(url.origin, '')
}
